import * as React from 'react';

export interface CloseOnBlurProps {
  onBlur: (clicked: boolean) => void;
  children?: React.ReactNode;
  dropdownRef?: React.RefObject<HTMLDivElement>;
}
export interface CloseOnBlurState {
  windowHasFocus: boolean;
  componentDidBlur: boolean;
}

export class CloseOnBlur extends React.Component<CloseOnBlurProps, CloseOnBlurState> {
  private timeoutHandle: any;
  public state:Readonly<CloseOnBlurState> = {
    windowHasFocus: true,
    componentDidBlur: false
  };

  public componentWillUnmount() {
    window.removeEventListener('blur', this.windowBlur);
    clearTimeout(this.timeoutHandle);
  }

  private windowBlur = () => {
    this.setState({
      windowHasFocus: false
    });
  };

  private isChild(elementInFocus: any, parent: HTMLDivElement) {
    let node = elementInFocus;
    while (node) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  /**
   * Swaps the execution order of window.blur and component.blur by delaying events by one tick.
   * DOM nodes can now be inspected while debugging.
   */
  private handleBlur = (event: any) => {
    if(this.props?.dropdownRef?.current?.contains(event.target)){
      return;
    }

    const crossBrowserTarget = event.nativeEvent.relatedTarget || event.nativeEvent.originalTarget || document.activeElement;

    const componentDidBlur = !this.isChild(
      crossBrowserTarget,
      event.currentTarget
    );

    this.setState({
      componentDidBlur
    });
    clearTimeout(this.timeoutHandle);
    this.timeoutHandle = setTimeout(this.delayedBlurEvent, 1);
  };

  private delayedBlurEvent = () => {

    const shouldTriggerOnBlur = this.state.componentDidBlur && this.state.windowHasFocus;

    window.removeEventListener('blur', this.windowBlur);
    this.setState({ componentDidBlur: false });
    if (shouldTriggerOnBlur) {
      this.props.onBlur(false);
    }
  };

  private handleFocus = () => {
    window.removeEventListener('blur', this.windowBlur);
    window.addEventListener('blur', this.windowBlur);
    this.setState({
      windowHasFocus: true
    });
  };

  public render() {
    return (<div
      onFocus={this.handleFocus}
      onBlur={this.handleBlur}
    >
      {this.props.children}
    </div>);
  }
}
